import { useToast } from '#providers/ToastProvider';
import { useUserInfo } from '#providers/UserInfo';
import copy from 'copy-to-clipboard';
import styled from 'styled-components';

interface NewFeatureProps {}

const NewFeature = ({}: NewFeatureProps) => {
  const { userInfo } = useUserInfo();
  const { showToast } = useToast();

  const profileUrl = userInfo?.myUrl
    ? `https://fibud.kr/expert/${userInfo.myUrl}`
    : null;

  const handleCopy = () => {
    if (profileUrl) {
      copy(profileUrl);
      showToast({
        message: '링크가 복사되었습니다.',
        type: 'success'
      });
    }
  };

  return (
    <>
      <Description>
        나만의 프로필 링크가 생성되었습니다.{'\n'}지금 바로 SNS에 공유해 보세요!
      </Description>
      {profileUrl && (
        <ProfileUrlWrapper>
          <Url>{profileUrl}</Url>
          <span onClick={handleCopy} style={{ paddingTop: '4px' }}>
            <CopyIcon />
          </span>
        </ProfileUrlWrapper>
      )}
    </>
  );
};

const Description = styled.div`
  margin-top: 40px;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.palette.gray100};
  text-align: center;
`;

const ProfileUrlWrapper = styled.div`
  margin-top: 40px;
  border-radius: 8px;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.palette.gray600};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Url = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.gray100};
`;

const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.25 2.5H12.1667C14.0335 2.5 14.9669 2.5 15.68 2.86331C16.3072 3.18289 16.8171 3.69282 17.1367 4.32003C17.5 5.03307 17.5 5.96649 17.5 7.83333V13.75M5.16667 17.5H11.9167C12.8501 17.5 13.3168 17.5 13.6733 17.3183C13.9869 17.1586 14.2419 16.9036 14.4017 16.59C14.5833 16.2335 14.5833 15.7668 14.5833 14.8333V8.08333C14.5833 7.14991 14.5833 6.6832 14.4017 6.32668C14.2419 6.01308 13.9869 5.75811 13.6733 5.59832C13.3168 5.41667 12.8501 5.41667 11.9167 5.41667H5.16667C4.23325 5.41667 3.76654 5.41667 3.41002 5.59832C3.09641 5.75811 2.84144 6.01308 2.68166 6.32668C2.5 6.6832 2.5 7.14991 2.5 8.08333V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5Z"
      stroke="#7750E9"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewFeature;
